import { Node, useNode } from "@craftjs/core";
import * as React from "react";
import styled from "styled-components";

const isNodeAllowed = (type) => ["Action"].includes(type);
export default function StandaloneNavigationList({
  children,
}: {
  children: React.ReactNode;
}) {
  const {
    connectors: { connect },
  } = useNode();

  return (
    <StandaloneNavigationListWrapper ref={connect}>
      {children}
    </StandaloneNavigationListWrapper>
  );
}

const StandaloneNavigationListWrapper = styled.div`
  display: contents;
`;

StandaloneNavigationList.craft = {
  custom: {
    displayName: "Standalone Navigation List",
  },
  rules: {
    canMoveIn: (nodes: Node[]) => {
      const nodeTypes = nodes.map((node) => node.type);
      return nodeTypes.length > 0 && nodeTypes.every(isNodeAllowed);
    },
  },
};
